module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_0.60c2a4bb.png";